import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { Typography as SwagupTypography } from '@swagup-com/components';
import { useHistory } from 'react-router-dom';
import EmptyFilterState from '../../assets/images/cart/empty-filter.png';
import { NavigateTo } from './common';
import { BackArrowIcon } from '../icons';
import { useResponsive } from '../../hooks';

const styles = () => ({
  icon: {
    marginTop: '4px !important'
  },
  wrapperMobile: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    width: '100%',
    padding: '40px 20px'
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    padding: '40px'
  },
  backToCatalog: {
    display: 'flex',
    alignContent: 'center',
    width: '180px',
    margin: '0px auto',
    cursor: 'pointer',
    gap: '8px',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

const useStyles = makeStyles(styles);

const BaseEmptyState = ({ wrapperClass, subtitleVariant, subtitleStyle, subtitleText, typographyStyle }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Grid container className={wrapperClass}>
      <Grid item>
        <SwagupTypography variant="h4SemiBoldInter">
          It looks like nothing matches your current filters
        </SwagupTypography>
      </Grid>
      <Grid item style={subtitleStyle}>
        <SwagupTypography variant={subtitleVariant} style={typographyStyle}>
          {subtitleText}
        </SwagupTypography>
      </Grid>
      <Grid item>
        <img src={EmptyFilterState} title="Filter empty state" width={300} height={300} />
      </Grid>
      <Grid item onClick={() => NavigateTo(history, '/catalog')}>
        <SwagupTypography variant="buttonMediumInter" className={classes.backToCatalog}>
          <BackArrowIcon className={classes.icon} />
          Back To Shopping
        </SwagupTypography>
      </Grid>
    </Grid>
  );
};

const MobileTabletEmptyState = () => {
  const classes = useStyles();
  return (
    <BaseEmptyState
      wrapperClass={classes.wrapperMobile}
      subtitleVariant="subtitle2RegularInter"
      subtitleStyle={{ marginTop: '20px', marginBottom: '8px' }}
      subtitleText="Don’t worry - try changing your filters or starting fresh to discover great options!"
    />
  );
};

const LaptopEmptyState = () => {
  const classes = useStyles();

  return (
    <BaseEmptyState
      wrapperClass={classes.wrapperMobile}
      subtitleVariant="subtitle2RegularInter"
      subtitleStyle={{ paddingTop: '20px', paddingBottom: '8px', margin: '0px auto', width: '650px' }}
      subtitleText="Don’t worry - try changing your filters or starting fresh to discover great options!"
      typographyStyle={{ fontWeight: 500 }}
    />
  );
};

const DesktopEmptyState = () => {
  const classes = useStyles();

  return (
    <BaseEmptyState
      wrapperClass={classes.wrapper}
      subtitleVariant="h4SemiBoldInter"
      subtitleStyle={{ paddingTop: '20px', paddingBottom: '8px', margin: '0px auto', width: '650px' }}
      subtitleText="Don’t worry—try changing your filters or starting fresh to discover great options!"
      typographyStyle={{ fontWeight: 500 }}
    />
  );
};

const FilterEmptyState = () => {
  const { currentDevice, DEVICES_TYPE, isMobileOrTablet } = useResponsive();

  return (
    <>
      {isMobileOrTablet && <MobileTabletEmptyState />}
      {currentDevice === DEVICES_TYPE.LAPTOP && <LaptopEmptyState />}
      {currentDevice === DEVICES_TYPE.DESKTOP && <DesktopEmptyState />}
    </>
  );
};

export default FilterEmptyState;
